<template>
  <div class="home">
    <m-loading :loading="homeLoading" />
    <div class="wrap">
      <div class="banner">
        <div class="specialist">
          <div class="hotInfo">
            <van-swipe class="hotList" :autoplay="3000">
              <van-swipe-item v-for="(item, index) in activeInfos" :key="index" class="hotItem"
                @click="toActivePage(item)">
                <div class="apl-btn-txt">
                  {{ role === 0 ? "马上报名" : "查看活动" }}
                </div>
                <img :src="item.posterUrl" alt="" />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </div>
      <div class="overallLeft iconList">
        <div class="iconItem" v-for="(time, index) in iconlist" :key="index" :style="index == 0 ? 'margin-left:0px' : ''"
          @click="targetToPage(time.path)">
          <img class="iconImg" :src="time.url" alt="" />
          <p class="iconName">
            {{ time.name }}
          </p>
        </div>
      </div>
      <img v-if="imageExists"  @click="getexpertPath" class="expertPath" :src="imageUrl" alt="">
      <img v-draggable class="flowPath" @click="getflowPath" src="https://megagame-website.oss-cn-beijing.aliyuncs.com/flowPath.png" alt="" />
    
      <div class="content-main">

        <div class="content-main" v-if="activityContributeList && activityContributeList.length > 0">
          <div class="specialist">
            <sign-title title="投稿活动" :simplicity="true" />
            <div class="hotInfo">
              <van-swipe class="hotList" :autoplay="3000">
                <van-swipe-item v-for="(item, index) in activityContributeList" :key="index" class="hotItem"
                  @click="activityContributePage(item)">
                  <img :src="item.posterUrl" alt="" />
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
        </div>
        <!-- swiper -->
        <div class="swipe-img" v-if="swipeList.length > 0">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, i) in swipeList" :key="i" @click="chainSkip(item.url)">
              <img class="swipe-item" :src="item.img" alt="" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- news -->
        <div class="news-list">
          <div class="overallLeft tipDiv">
            <div :class="tipSelect == 2 ? 'select' : ''" @click="gettipSelect(2)">
              活动
            </div>
            <div :class="tipSelect == 1 ? 'select' : ''" @click="gettipSelect(1)">
              资讯
            </div>
          </div>
          <van-list v-show="tipSelect == 1" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div v-slidein class="news-item" v-for="(item, i) in newsList" :key="i" @click="toNewsDetail(item)">
              <div class="img-area">
                <img v-setshow :src="item.img" alt="" />
              </div>
              <div class="news-content">
                <p class="news-tit">{{ item.title }}</p>
                <div class="author">
                  {{ item.time }}
                </div>
              </div>
            </div>
          </van-list>
          <van-list v-show="tipSelect == 2" v-model="loadingActivity" :finished="finishedActivity" finished-text="没有更多了"
            @load="onLoadActivity">
            <div v-slidein class="news-item" style="display: block" v-for="(item, i) in swActivity" :key="i">
              <div class="news-item-content">
                <div class="img-area">
                  <img v-setshow :src="item.posterUrl" alt="" />
                </div>
                <div class="news-content">
                  <div class="news-tit">{{ item.name }}</div>
                  <div class="author2">
                    {{ item.startTime + "~" + item.endTime }}
                  </div>
                </div>
              </div>
              <div class="overallbaseline news-item-bottom">
                <div v-if="item.typeId == 0" class="overallCenter status ing">
                  进行中
                </div>
                <div v-if="item.typeId == 1" class="overallCenter status red">
                  已结束
                </div>
                <div v-if="item.typeId == 2" class="overallCenter status end">
                  未开始
                </div>
                <div class="overallCenter contributeBtn"  v-if="item.typeId == 0 || item.typeId == 2" @click="toActivePage(item)">
                  马上报名
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
    <!-- 专家信息 -->
    <van-popup v-model="showInfo" class="infos" closeable close-icon="arrow-down" close-icon-position="top-right"
      position="bottom" :style="{ height: '50%' }">
      <div class="info-wrap">
        <div class="i-header">
          <img :src="checkInfo.img" alt="" />
          <p>{{ checkInfo.name }}</p>
        </div>
        <div class="intro" v-html="checkInfo.intro"></div>
      </div>
    </van-popup>
    <!-- qrcode -->
    <van-popup v-model="showQrCode" class="qr-code-box" closeable position="bottom"
      :style="{ height: '100%', width: '100%' }">
      <div class="show-qr-code">
        <m-loading :loading="creating"></m-loading>
        <div class="qr-code-content" id="qr_code_content_org"></div>
      </div>
    </van-popup>
    <van-popup v-model="showChaQrCode" class="qr-code-box" closeable position="bottom"
      :style="{ height: '100%', width: '100%' }">
      <div class="show-qr-code">
        <m-loading :loading="creating"></m-loading>
        <div :class="['qr-code-content', role === 3 ? 'channel' : '']" id="qr_code_content_cha"></div>
      </div>
    </van-popup>
    <!-- 联系我们 -->
    <van-popup v-model="showContactUs" class="photo-tags" closeable position="bottom"
      :style="{ height: '100%', width: '100%' }">
      <div class="show-photo-tags">
        <img src="../../assets/images/home/lianxiwomen.png" />
        <div class="title">联系方式</div>
        <p class="content">
          <span>联系电话：</span>
          <span>{{ ContactUs && ContactUs.Hotline }}</span>
        </p>
        <p class="content">
          <span>单位地址：</span>
          <span>{{ ContactUs && ContactUs.address }}</span>
        </p>
        <p class="content">
          <span>邮 箱：</span>
          <span>{{ ContactUs && ContactUs.mailbox }}</span>
        </p>
      </div>
    </van-popup>
    <!-- 重要通知弹窗 -->
    <van-popup v-model="showNotice" class="notice-dialog" closeable close-icon="cross"
      close-icon-position="top-right" round>
      <div class="notice-wrap">
        <div class="notice-title">重要通知</div>
        <div class="notice-content">
          您好，本届比赛公示及申诉期已结束，请及时关注“学与玩杂志”微信公众号通知，耐心等待评审结果正式发布。感谢支持。
        </div>
        <div class="notice-date">发布日期：2026年9月13日</div>
      </div>
    </van-popup> 
    <Bottom/>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import {
  homePageData,
  getPageArticle,
  getactivityContributeList,
  getPageActivity,
  getContactUs
} from "@/utils/api/home";
import { bindInstitution } from "@/utils/api/user";
import { signature } from "@/utils/mixin/wx-js-sdk-signature";
import { MakeCard } from "../../utils/make-canvas-card";
import { areaList } from "@vant/area-data";
import Bottom from "@/components/home/BottomBar.vue";
import { localStorageGetItem } from "@/utils/auth";
export default {
  mixins: [signature],
  components: {
    "sign-title": SignTitle,
    Bottom
  },
  data() {
    return {
      // 角色
      role: -1,
      // 专家信息
      checkInfo: {},
      // 信息弹窗key
      showInfo: false,
      // 显示报名服务单位二维码卡片
      showQrCode: false,
      // 显示渠道二维码卡片
      showChaQrCode: false,
      // 是否制作完成
      creating: false,
      // 页面loading
      homeLoading: true,
      // 轮播图数据
      swipeList: [],

      tipSelect: 2,
      // 是否加载资讯所有数据
      // 新闻loading
      loading: false,
      finished: false,
      newsList: [],
      page: 0,

      // 是否加载活动所有数据
      loadingActivity: false,
      finishedActivity: false,
      swActivity: [],
      pageActivity: 0,

      activeInfos: null,
      // 定位、扫码、分享朋友/qq、分享朋友圈/qq空间,
      jsApiList: [
        "getLocation",
        "scanQRCode",
        "updateAppMessageShareData",
        "updateTimelineShareData"
      ],
      // 报名服务单位信息
      orgInfo: {},
      // 渠道信息
      chaInfo: {},
      // 是否登录
      isLogin: false,
      activityContributeList: [],
      iconlist: [
        {
          name: "赛事活动",
          url: require("../../assets/images/home/icon_saishihuodong.png"),
          path: "/activityList/1"
        },
        {
          name: "我的报名",
          url: require("../../assets/images/home/icon_baoming.png"),
          path: "/activityList/2"
        },
        {
          name: "新闻资讯",
          url: require("../../assets/images/home/icon_xinwen.png"),
          path: "/informationList"
        },
        {
          name: "联系我们",
          url: require("../../assets/images/home/icon_lianxiwomen.png"),
          path: "false"
        }
      ],
      showContactUs: false,
      ContactUs: "",
      imageUrl:'',
      imageExists:false,
      // 重要通知弹窗
      showNotice: false,
    };
  },
  computed: {
  
  },
  async mounted() {
    document.title = "全国中小学生竞赛展演活动智慧服务平台";
    this.imageUrl = 'https://megagame-website.oss-cn-beijing.aliyuncs.com/banner0.png'
    this.checkImageExists(this.imageUrl, (exists) => {
      this.imageExists = exists;
    });
    const userInfo = this.$store.state.userInfo;
    this.isLogin = JSON.stringify(userInfo) !== "{}";
    this.role = this.isLogin ? this.$store.state.role : 0;
    if (this.role === 2) {
      const { name, logo, qrCode } = userInfo.t;
      this.orgInfo = {
        name,
        // 解决 canvas 使用 toDataURL 图片跨域问题
        logo: this.replaceOss(logo),
        qrCode: this.replaceOss(qrCode)
      };
    }
    if (this.role === 3) {
      const { name, userImg, qrCode, registerCode } = userInfo.t;
      this.chaInfo = {
        name,
        logo: this.replaceOss(userImg),
        qrCode: this.replaceOss(qrCode),
        registerCode
      };
    }
    this.getPageData();
    this.getactivityContribute();
    this.onLoadActivity();
    this.getgetContactUs();
    // 每次打开首页弹出重要通知
    if (new Date().getTime() > new Date('2026-09-13 00:00:01').getTime()) {
      this.showNotice = true;
    }
  },
  methods: {
        // 检查图片是否存在
    checkImageExists(url, callback) {
      const img = new Image();
      img.onload = () => {
        callback(true); // 图片存在
      };
      img.onerror = () => {
        callback(false); // 图片不存在
      };
      img.src = url;
    },
    getlocalStorageGetItem(type) {
      return localStorageGetItem(type);
    },
    // 获取联系我们
    getgetContactUs() {
      getContactUs().then((res) => {
        if (res.success) {
          if (res.data.length > 0) {
            let ContactUs = res.data[0];
            this.ContactUs = JSON.parse(ContactUs.keyValue);
          }
        }
      });
    },
    // 跳转活动页面
    toActivePage(item) {
      window.localStorage.setItem(
        "active_infos_data",
        JSON.stringify(item)
      );
      this.$router.push("/home/apply");
    },
    // 选择
    gettipSelect(value) {
      this.tipSelect = value;
      if(value==1){
        if(this.page == 0){
          this.onLoad()
        }
      }
    },
    // icon跳转
    targetToPage(path) {
      if (path === 'false') {
        this.showContactUs = true
      } else {
        this.$router.push(path);
      }
    },
    // 专家跳转
    getexpertPath() {

    },
    // 外链跳转
    chainSkip(url) {
      window.location.href = url;
    },
    // 定位
    getGeolocation() { },
    // 新闻list数据
    onLoad() {
      this.loading = true;
      this.page++;
      getPageArticle({
        pageNo: this.page,
        includeExternalLink: localStorage.getItem("port") == "douyin" ? 0 : 1,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          let newsList = res.data.records.map((e) => {
            return {
              title: e.title,
              isExternalLink: e.isExternalLink,
              externalLinkUrl: e.externalLinkUrl,
              img: e.cover,
              content: e.contents,
              id: e.id,
              intro: e.subTitle,
              authorHead: e.addUserImg,
              time: e.addTime || e.updateTime,
              authorName: e.addUserName
            };
          });
          this.newsList.push(...newsList);
          if (this.page * 10 >= res.data.total) this.finished = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = true;
        }
      });
    },
    // 活动列表数据
    onLoadActivity() {
      this.loadingActivity = true;
      this.pageActivity++;
      getPageActivity({
        pageNo: this.pageActivity,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          let swActivity = res.data.records
          this.swActivity.push(...swActivity);
          if (this.pageActivity * 10 >= res.data.total) this.finishedActivity = true;
          this.loadingActivity = false;
        } else {
          this.loadingActivity = false;
          this.finishedActivity = true;
        }
      });
    },
    // 打开专家详情
    specialistDetail(item) {
      this.checkInfo = item;
      this.showInfo = true;
    },
    // 打开新闻详情
    toNewsDetail(item) {
      if (item.isExternalLink == 1) {
        window.location.href = item.externalLinkUrl;
      } else {
        window.localStorage.setItem(
          "home_news_detail_infos",
          JSON.stringify(item)
        );
        
        this.$router.push({
          path: "/home/newsdetail",
          query: {
            item: JSON.stringify(item)
          }
        });
      }
    },
    /**
     * @description: 获取投稿活动
     * @author: wangxiaoheng
     */
    getactivityContribute() {
      getactivityContributeList().then(res => {
        if (res.success) {
          this.activityContributeList = res.data
        }
      })
    },
    activityContributePage(item) {
      window.localStorage.setItem(
        "activity_Contribute_data",
        JSON.stringify(item)
      );
      this.$router.push("/home/activityContribute");
    },
    // 获取页面数据
    getPageData(def = false) {
      homePageData({ province: "北京市" }).then(
        (res) => {
          if (res.success) {
            const {
              bannerList,
              swActivityTbl
            } = res.data;
            let swipeList = bannerList && bannerList.map((e) => {
              return {
                img: e.imgUrl,
                url: e.skipUrl,
                name: e.name
              };
            });
            let datas = [...swActivityTbl].sort((a, b) => {
              if (b.score == null) return -1;
              if (a.score == null) return 1;
              return b.score - a.score;
            });
            this.swipeList = swipeList;
            this.activeInfos = datas;
            this.homeLoading = false;
          }
        }
      );
    },
    // canvas 制作二维码卡片
    makeCardByCanvas() {
      this.creating = true;
      this.showQrCode = true;
      let width = 304;
      let height = 394;
      let options = {
        el: "qr_code_content_org",
        width,
        height,
        multiple: 2,
        className: "card",
        els: [
          {
            type: "img",
            url: this.orgInfo.logo,
            x: (width - 54) / 2,
            y: 32,
            w: 54,
            h: 54,
            round: true
          },
          {
            type: "text",
            center: true,
            // x: width / 2,
            y: 105,
            color: "#333",
            fontSize: 16,
            weight: "700",
            text: this.orgInfo.name
          },
          {
            type: "img",
            url: this.orgInfo.qrCode,
            x: (width - 148) / 2,
            y: 140,
            w: 148,
            h: 148,
            round: false
          },
          {
            type: "text",
            center: true,
            y: 308,
            color: "#999",
            fontSize: 12,
            text: "扫描上方二维码即可绑定我的报名服务单位"
          },
          {
            type: "text",
            center: true,
            y: 340,
            color: "#999",
            fontSize: 12,
            text: "长按二维码即可保存或分享"
          }
        ],
        success: () => {
          this.creating = false;
        }
      };
      this.$nextTick(() => {
        let makeCard = new MakeCard(options);
        makeCard.create();
      });
    },
    // canvas 制作渠道二维码卡片
    makeChaCardByCanvas() {
      this.creating = true;
      this.showChaQrCode = true;
      let width = 304;
      let height = 432;
      let options = {
        el: "qr_code_content_cha",
        width,
        height,
        multiple: 2,
        className: "card",
        els: [
          {
            type: "img",
            url: this.chaInfo.logo,
            x: (width - 54) / 2,
            y: 32,
            w: 54,
            h: 54,
            round: true
          },
          {
            type: "text",
            center: true,
            // x: width / 2,
            y: 105,
            color: "#333",
            fontSize: 16,
            weight: "700",
            text: this.chaInfo.name
          },
          {
            type: "img",
            url: this.chaInfo.qrCode,
            x: (width - 148) / 2,
            y: 120,
            w: 148,
            h: 148,
            round: false
          },
          {
            type: "roundrect",
            x: 59,
            y: 284,
            w: 186,
            h: 40,
            r: 4,
            color: "#6CDD8F",
            lineWidth: 1
          },
          {
            type: "text",
            center: true,
            y: 304,
            color: "#6CDD8F",
            fontSize: 20,
            weight: "700",
            text: this.chaInfo.registerCode
          },
          {
            type: "text",
            center: true,
            y: 350,
            color: "#999",
            fontSize: 12,
            text: "扫描上方二维码即可绑定赛事组织单位"
          },
          {
            type: "text",
            center: true,
            y: 390,
            color: "#999",
            fontSize: 12,
            text: "长按二维码即可保存或分享"
          }
        ],
        success: () => {
          this.creating = false;
        }
      };
      this.$nextTick(() => {
        let makeCard = new MakeCard(options);
        makeCard.create();
      });
    },
    replaceOss(str) {
      return (
        str
          // 客户oss服务地址
          .replace(
            "https://motherland-h5.oss-cn-beijing.aliyuncs.com",
            "/oss-h5"
          )
          // 测试服oss地址
          .replace("https://motherlandh5.oss-cn-beijing.aliyuncs.com", "/ossh5")
      );
    },
    /**
     * @description: 跳转报名流程
     * @author: wangxiaoheng
     */
    getflowPath() {
      this.$router.push('/flowPath')
    },
  },

};
</script>

<style lang="scss" scoped>
.home {
  height: 100%;

  .wrap {
    min-height: 100vh;
    background-color: #F8F8F9;
    padding-bottom: 100px;

    .org-head {
      position: relative;
      display: flex;
      justify-content: space-between;
      height: 44px;
      align-items: center;
      padding: 0 12px;
      background-color: #fff;

      .location {
        width: 60px;
        display: flex;
        align-items: center;

        img {
          margin-right: 4px;
          width: 10px;
        }

        span {
          flex: 1;
          font-size: 12px;
          transform: scale(0.9);
        }
      }

      .search-box {
        width: 254px;
        border: 1px solid #6cdd8f;
        height: 24px;
        font-size: 12px;
        color: #054b1b33;
        border-radius: 12px;
        line-height: 24px;
      }

      .show-qr-code {
        height: 24px;
        width: 24px;

        img {}
      }
    }

    .cha-head {
      position: relative;
      display: flex;
      justify-content: space-between;
      height: 44px;
      align-items: center;
      padding: 0 12px;
      background-color: #fff;

      .location {
        width: 100px;
        display: flex;
        align-items: center;

        &>div {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        img {
          margin-right: 4px;
          width: 10px;
        }

        span {
          font-size: 12px;
          transform: scale(0.9);
        }

        .show-qr-code {
          margin-left: 12px;
          height: 16px;
          width: 16px;

          img {
            height: 100%;
            width: 100%;
          }
        }
      }

      .cha-name {
        display: flex;
        align-items: center;
        max-width: 5rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        img {
          height: 24px;
          width: 24px;
          border-radius: 12px;
        }

        span {
          margin-left: 5px;
          font-size: 14px;
          color: #333;
        }
      }
    }

    .banner {
      width: 100%;
      height: 160px;
      position: relative;
      overflow: hidden;

      .specialist {
        margin-top: 10px;
        padding-left: 12.5px;
        padding-right: 22.5px;

        .hotInfo {
          .hotList {
            padding-bottom: 10px;
            overflow: visible;
            box-sizing: border-box;

            .hotItem {
              box-sizing: border-box;
              display: inline-flex;
              width: 330px;
              height: 150px;
              padding-left: 10px;

              img {
                border-radius: 8px;
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      &.channel {
        background-color: unset;
        // margin-bottom: 40px;
      }

      .float-box {
        position: absolute;
        top: 17px;
        right: 13px;
        width: 69px;
        height: 22px;
        border-radius: 11px;
        background: #ffffff;
        opacity: 0.8;
        z-index: 10;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 7.5px;

        .scan {
          height: 13px;
          width: 13px;

          img {
            height: 13px;
            width: 13px;
          }
        }

        .location {
          display: flex;
          align-items: center;

          img {
            height: 14px;
            width: 10px;
          }

          p {
            font-size: 12px;
            color: #64c582;
            transform: scale(0.8);
            width: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      @keyframes scaleDraw {

        /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
        0% {
          transform: scale(1);
          /*开始为原始大小*/
        }

        25% {
          transform: scale(1.2);
          /*放大1.1倍*/
        }

        50% {
          transform: scale(1);
        }

        75% {
          transform: scale(1.1);
        }
      }

      .apl-btn-txt {
        // font-size: 14px;
        // color: #fff;
        // line-height: 20px;
        // height: 20px;
        // width: 140px;
        // position: absolute;
        // bottom: -10px;
        // left: calc((100% - 140px) / 2);
        position: absolute;
        top: 110px;
        left: 120px;
        width: 101px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #0d9f3b;
        background-color: #fff;
        border-radius: 12.5px;
        -webkit-animation-name: scaleDraw;
        /*关键帧名称*/
        -webkit-animation-timing-function: ease-in-out;
        /*动画的速度曲线*/
        -webkit-animation-iteration-count: infinite;
        /*动画播放的次数*/
        -webkit-animation-duration: 5s;
        /*动画所花费的时间*/
      }

      .apply-btn {
        position: absolute;
        width: 140px;
        height: 40px;
        background: -webkit-linear-gradient(180deg,
            rgba(55, 220, 141, 1) -15%,
            rgba(30, 191, 95, 1) 100%);
        background: linear-gradient(-90deg,
            rgba(55, 220, 141, 1) -15%,
            rgba(30, 191, 95, 1) 100%);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        bottom: -20px;
        left: calc((100% - 140px) / 2);
        animation: applayAnm 3s ease-in-out infinite;

        @keyframes applayAnm {
          50% {
            // height: 44px;
            // width: 150px;
            // left: calc((100vw - 150px) / 2);
            // bottom: -22px;
            transform: scale(1.1);
          }

          100% {
            // height: 40px;
            // width: 140px;
            // left: calc((100vw - 140px) / 2);
            // bottom: -20px;
            transform: scale(1);
          }
        }
      }
    }

    .iconList {
      padding: 0 20px;
      margin-top: 15px;
      margin-bottom: 20px;

      .iconItem {
        margin-left: 31px;

        .iconImg {
          box-sizing: border-box;
          width: 61px;
          height: 61px;
        }

        .iconName {
          margin-top: 2px;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }
    }

    .expertPath {
      box-sizing: border-box;
      width: 345px;
      height: 95px;
      border-radius: 8px;
    }

    .content-main {
      width: 375px;

      .specialist {
        padding: 0 20px;
        margin-bottom: 10px;

        .list-wrap {
          height: 130px;
          display: flex;
          flex-direction: column;

          .spec-tit {
            font-size: 12px;
            height: 40px;
            font-size: 16px;
            line-height: 40px;
            font-weight: 700;
            text-align: left;
            color: #333;
          }

          .roll-block {
            overflow-x: scroll;
            flex: 1;
            padding-bottom: 10px;

            .spec-list {
              height: 100%;
              display: flex;
              flex-wrap: nowrap;

              .spec-item {
                height: 100%;
                width: 50px;
                display: flex;
                flex-direction: column;
                margin: 0 10px;
                justify-content: center;
                align-items: center;

                img {
                  width: 50px;
                  height: 50px;
                  border-radius: 25px;
                }

                p {
                  margin-top: 5px;
                  font-size: 12px;
                  max-width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  color: #666;
                }
              }
            }
          }
        }

        .final-list {
          border-bottom: 1px solid #f2f2f2;
        }

        .hotInfo {
          .hotList {
            padding-bottom: 10px;

            .hotItem {
              display: inline-flex;
              width: 195px;
              height: 186px;

              img {
                border-radius: 8px;
                width: 100%;
                height: 100%;
              }
            }
          }
        }

      }

      .swipe-img {
        min-height: 220px;
        overflow: hidden;
        // padding-top: 20px;
        padding-bottom: 10px;

        // &.org {
        //   padding-top: 15px;
        //   height: 235px;
        // }
        &.channel {
          background-color: #fff;
          padding-top: 0;
        }

        .my-swipe {
          width: 335px;
          height: 188px;
          margin: 0 auto;
          margin-top: 20px;
          border-radius: 15px;

          .swipe-item {
            width: 100%;
          }
        }
      }

      .news-list {
        margin-top: 10px;
        padding: 0 20px;

        .tipDiv {
          margin-top: 27px;
          margin-bottom: 22px;

          div {
            width: 70px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            color: #999999;
            line-height: 19px;
            text-align: left;
          }

          .select {
            position: relative;
            font-size: 20px;
            font-weight: bold;
            color: #222222;
            line-height: 23px;
          }

          .select::before {
            position: absolute;
            content: "";
            display: inline-block;
            width: 19px;
            height: 6px;
            background-image: url("../../assets/images/home/icon_label.png");
            background-size: cover;
            background-position: center;
            bottom: -9px;
            left: 11px;
          }
        }

        .news-item {
          display: flex;
          background: #FFFFFF;
          border-radius: 8px 8px 8px 8px;
          padding: 15px;
          margin-bottom: 15px;

          .news-item-content {
            display: flex;
          }

          .img-area {
            width: 120px;
            min-width: 120px;
            height: 60px;
            border-radius: 10px;
            border: 1px solid #f2f2f2;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }

            img {
              object-fit: cover;
              width: inherit !important;
            }
          }

          .news-content {
            margin-left: 10px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .news-tit {
              max-width: 180px;
              text-align: left;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC;
              font-weight: bold;
              color: #222222;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              -moz-line-clamp: 2;
              -moz-box-orient: vertical;
            }

            .author {
              height: 24px;
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #999;
              margin-left: 3px;
              max-width: 160px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .author2 {
              // max-width: 160px;
              height: 24px;
              display: flex;
              align-items: center;
              font-size: 10px;
              color: #999;
              margin-left: 3px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transform: scale(0.7);
              transform-origin: left;
            }
          }

          .news-item-bottom {
            margin-top: 11px;
            border-top: 1px solid #F0F0F0;
            padding-top: 13px;
          }

          .status {
            font-size: 12px;
            height: 20px;
            text-align: center;
            width: 50px;
            border-radius: 25px 25px 25px 25px;
            color: #FF7246;
            background-color: rgba(255, 114, 70, 0.1);

            &.end {
              background-color: #eee;
            }

            &.red {
              background-color: red;
              color: #ffffff;
            }
          }

          .contributeBtn {
            width: 70px;
            height: 25px;
            background: #31D076;
            border-radius: 25px 25px 25px 25px;
            opacity: 1;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 14px;
          }
        }

      }
    }
  }
}
</style>
<style lang="scss">
.home {
  .van-popup.infos {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;

    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;

      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }

  .van-popup.qr-code-box {
    background-color: unset;

    .show-qr-code {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      overflow: hidden;

      .qr-code-content {
        width: 304px;
        height: 394px;
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;
        margin-top: 10vh;
        display: flex;
        flex-direction: column;
        align-items: center;

        &.channel {
          height: 432px;
        }

        img {
          &.card {
            height: 100%;
            width: 100%;
          }

          &.logo {
            width: 54px;
            height: 54px;
            margin-top: 32px;
            border-radius: 50%;
          }

          &.qr-code {
            width: 148px;
            height: 148px;
            margin-top: 12px;
          }

          &.down-ico {
            width: 24px;
            height: 24px;
            margin-top: 27px;
          }
        }

        div {
          font-size: 16px;
          color: #333;
          margin-top: 8px;
          line-height: 22px;
          font-weight: bold;
        }

        p {
          font-size: 12px;
          color: #999;
          line-height: 18px;
          margin-top: 12px;
        }

        span {
          display: block;
          width: 186px;
          height: 40px;
          border: 1px solid #6cdd8f;
          border-radius: 4px;
          font-size: 20px;
          font-weight: bold;
          color: #6cdd8f;
          text-align: center;
          line-height: 40px;
          margin-top: 12px;
        }
      }

      .share-content {
        width: 375px;
        max-width: 10rem;
        height: 120px;
        border-radius: 16px 16px 0px 0px;
        background: #ffffff;
        bottom: 0px;
        display: flex;
        flex-direction: column;

        .share-ways {
          flex: 1;
          padding: 0 69px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          img {
            height: 70px;
            width: 70px;
          }
        }

        .share-cancel {
          height: 55px;
          text-align: center;
          line-height: 55px;
          font-size: 16px;
          color: #333;
          border-top: 1px solid #eee;
        }
      }
    }
  }

  .van-popup.notice-dialog {
    width: 300px;
    border-radius: 16px;
    overflow: visible;

    .notice-wrap {
      padding: 24px 18px 18px;

      .notice-title {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #222222;
        text-align: center;
      }

      .notice-content {
        margin-top: 14px;
        font-size: 13px;
        font-family: PingFang SC, PingFang SC;
        color: #666666;
        line-height: 22px;
        text-align: justify;
      }

      .notice-date {
        margin-top: 14px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        color: #999999;
        text-align: right;
      }
    }

    .van-icon-cross {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 18px;
      color: #c8c9cc;
    }
  }

  .van-popup.photo-tags {
    background-color: unset;
    display: flex;
    align-items: center;
    justify-content: center;

    .show-photo-tags {
      width: 300px;
      min-height: 276px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;

      img {
        width: 164px;
        height: 46px;
        margin: 0 auto;
        margin-top: 17px;
      }

      .title {
        display: flex;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #31D076;
        padding-left: 20px;
        margin-top: 30px;

        &::before {
          display: inline-block;
          content: "";
          width: 2px;
          height: 14px;
          background: #31D076;
          position: relative;
          top: 4px;
          margin-right: 10px;
        }
      }

      .content {
        text-align: left;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
        padding-left: 27px;
        padding-right: 5px;
        margin-top: 12px;

        span {
          flex: 1 1 auto;
          min-width: 70px;
        }

        span:last-child {
          color: #222222;
        }
      }
    }
  }
}

.info-wrap {
  margin-top: 50px;
  padding: 0 20px;
  height: 100%;
  overflow-y: scroll;

  .i-header {
    img {
      width: 80px;
      height: 80px;
      border-radius: 40px;
    }

    p {
      font-size: 14px;
      color: #666;
    }
  }

  .intro {
    margin-top: 20px;
    line-height: 24px;
    font-size: 14px;
    color: #999;
    padding-bottom: 80px;
  }
}

.flowPath {
  position: fixed;
  right: 19px;
  bottom: 190px;
  width: 74px;
  height: 58px;
  z-index: 1000;
}</style>
